import { AccessLevel, ObjectPermission } from '../../types';
import { useAppContext } from '../apps/AppContext';

export const ACCESS_LEVELS: AccessLevel[] = ['none', 'read', 'write', 'full'];

const LEVEL_RANK: Record<AccessLevel, number> = {
  none: 0,
  read: 1,
  write: 2,
  full: 3,
};

export function getAccessLevel(permissions: ObjectPermission[], objectType: string): AccessLevel {
  const perm = permissions.find(p => p.objectType === objectType);
  return perm?.accessLevel ?? 'none';
}

export function canAccess(
  permissions: ObjectPermission[],
  objectType: string,
  required: AccessLevel = 'read'
): boolean {
  const level = getAccessLevel(permissions, objectType);
  return LEVEL_RANK[level] >= LEVEL_RANK[required];
}

export function canAccessAny(
  permissions: ObjectPermission[],
  objectTypes: string[],
  required: AccessLevel = 'read'
): boolean {
  return objectTypes.some(t => canAccess(permissions, t, required));
}

export function useCanAccess(objectType: string, required: AccessLevel = 'read'): boolean {
  const { roleAccess } = useAppContext();
  if (roleAccess?.isAdmin) {
    return true;
  }
  if (!roleAccess) {
    return false;
  }
  return canAccess(roleAccess.permissions ?? [], objectType, required);
}
